export enum CopilotCommand {
  translate = 'TRANSLATE',
  summarize = 'SUMMARIZE',
  explain = 'EXPLAIN',
  start_chat = 'START_CHAT',
}
